import classNames from 'classnames';
import React, { useState } from 'react';
const LoginModal = React.lazy(() => import('@components/login/LoginModal'));
const EditorialText = (props) => {
    const [loginOpen, setLoginOpen] = useState(false);
    if (props.button.type === 'My Area Link') {
        return (React.createElement("a", { href: props.accountUrl, className: classNames('button', `button--${props.button.ctaStyle}`, props.customClass, {
                [`button--${props.button.ctaStyle}-inverted`]: props.button.ctaStyleInverted,
                [`button--arrow-${props.button.ctaArrow}`]: props.button.ctaArrow !== 'none',
            }) }, props.button.title));
    }
    if (props.button.type === 'Login Registration Popup') {
        return (React.createElement(LoginModal, Object.assign({}, props, { reloadPage: true, modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status), buttonText: props.button.title, customClass: classNames('button', `button--${props.button.ctaStyle}`, props.customClass, {
                [`button--${props.button.ctaStyle}-inverted`]: props.button.ctaStyleInverted,
                [`button--arrow-${props.button.ctaArrow}`]: props.button.ctaArrow !== 'none',
            }), privacypolicy: props.privacypolicy, forgotpasswordform: props.forgotpasswordform, customModalId: props.button.customModalId })));
    }
    return React.createElement("div", null);
};
export default EditorialText;
